// extracted by mini-css-extract-plugin
export default {"card":"_cardsAdmin_card__aOPJa","type":"_cardsAdmin_type__l+-5a"};